import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
function FeaturedProperties({ data }) {
  return (
    <section className="properties__grid properties__grid--two section__space__top">
      <div className="container">
        <div className="properties__grid__area wow fadeInUp">
          <div className="title__with__cta">
            <div className="row d-flex align-items-center">
              <div className="col-lg-8">
                <h2 className="text-white">Featured Properties</h2>
              </div>
              <div className="col-lg-4">
                <div className="text-start text-lg-end">
                  <Link
                    to="/buy"
                    className="button button--secondary button--effect"
                  >
                    Browse All Properties
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="property__grid__wrapper">
            <div className="row">
              {data.map((item, ind) => (
                <div key={ind} className="col-lg-6 col-xl-4">
                  <div className="property__grid__single column__space--secondary">
                    <div className="img__effect">
                      <Link to="/explore">
                        <img src={imageUrl(item.img)} alt="Property" />
                      </Link>
                    </div>
                    <div className="property__grid__single__inner">
                      <h4>{item.city}</h4>
                      <p className="sub__info">
                        <i className="fa-solid fa-location-dot"></i>{" "}
                        {item.location}
                      </p>
                      <div className="progress__type">
                        <div className="countdown__wrapper d-flex align-items-center w-100">
                          <p className="secondary">
                            {item.bed} <i class="fa-solid fa-bed mx-1"></i>
                          </p>
                          <p className="secondary mx-3">
                            {item.bath}
                            <i class="fa-solid fa-bath mx-1"></i>
                          </p>
                        </div>
                        <p className="project__has">
                          <span className="project__has__investors">
                            {item.nftAddress}
                          </span>{" "}
                        </p>
                      </div>
                      <div className="item__info">
                        <div className="item__info__single">
                          <p>Property Size</p>
                          <h6>{item.size} sqft</h6>
                        </div>
                        <div className="item__info__single">
                          <p>Property Type</p>
                          <h6>{item.type}</h6>
                        </div>
                      </div>
                      <div className="invest__cta__wrapper">
                        <div className="countdown__wrapper d-flex justify-content-around w-100">
                          <p className="secondary">
                            <i className="fa-solid fa-clock"></i> Price
                          </p>
                          <div className="countdown">
                            <h5>
                              <span className="days">{item.price} ETH </span>
                            </h5>
                            <h6>
                              <span className="hours">RM{item.priceIn$}</span>
                            </h6>
                          </div>
                        </div>
                        <div className="invest__cta">
                          <a
                            href="property-details.html"
                            className="button button--effect"
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedProperties;
